export default __webpack_public_path__ + "static/media/closeicon.3bc25819.svg";